export const INCOMING_INVOICE_CREATED = "INCOMING_INVOICE_CREATED";
export const INCOMING_INVOICE_UPDATED = "INCOMING_INVOICE_UPDATED";
export const INCOMING_INVOICE_UPDATED_CONTENT = "INCOMING_INVOICE_UPDATED_CONTENT";
export const INCOMING_INVOICE_ACCEPTED = "INCOMING_INVOICE_ACCEPTED";
export const INCOMING_INVOICE_FORWARDED = "INCOMING_INVOICE_FORWARDED";
export const INCOMING_INVOICE_SENT_BACK = "INCOMING_INVOICE_SENT_BACK";
export const INCOMING_INVOICE_CONVERTED = "INCOMING_INVOICE_CONVERTED";
export const INCOMING_INVOICE_CANCELLED = "INCOMING_INVOICE_CANCELLED";
export const INCOMING_INVOICE_SNOOZED = "INCOMING_INVOICE_SNOOZED";
export const AGING_INCOMING_INVOICE_SNOOZED = "AGING_INCOMING_INVOICE_SNOOZED";
export const AGING_INCOMING_INVOICE_SUBMITTED = "AGING_INCOMING_INVOICE_SUBMIT";
